// components/ListEditor.tsx
import React, { useState, useEffect, KeyboardEvent } from "react";
import {
    Box,
    Chip,
    IconButton,
    TextField,
    Typography,
    Stack
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

interface ListEditorProps {
    label?: string;
    items: string[];
    onChange: (items: string[]) => void;
}

const ListEditor: React.FC<ListEditorProps> = ({ label = "Options", items, onChange }) => {
    const [inputValue, setInputValue] = useState("");

    useEffect(() => {
        setInputValue("");
    }, [items]);

    const addItem = () => {
        const trimmed = inputValue.trim();
        if (trimmed && !items.includes(trimmed)) {
            onChange([...items, trimmed]);
            setInputValue("");
        }
    };

    const handleKeyDown = (e: KeyboardEvent<HTMLInputElement>) => {
        if (e.key === "Enter") {
            e.preventDefault();
            addItem();
        }
    };

    const removeItem = (index: number) => {
        const updated = [...items];
        updated.splice(index, 1);
        onChange(updated);
    };

    return (
        <Box>
            <Typography variant="subtitle2" gutterBottom>{label}</Typography>
            <Stack direction="row" flexWrap="wrap" gap={1} mb={1}>
                {items.map((item, index) => (
                    <Chip
                        key={index}
                        label={item}
                        onDelete={() => removeItem(index)}
                        deleteIcon={<CloseIcon />}
                    />
                ))}
            </Stack>
            <TextField
                fullWidth
                size="small"
                placeholder="Type an option and press Enter"
                value={inputValue}
                onChange={(e) => setInputValue(e.target.value)}
                onKeyDown={handleKeyDown}
            />
        </Box>
    );
};

export default ListEditor;
